import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for auth to finish initialising before checking role
    if (authLoading) return;

    if (!user) { setIsAdmin(false); setLoading(false); return; }

    let cancelled = false;

    (async () => {
      // Ensure a fresh session token is available before the RLS query
      await supabase.auth.getSession();

      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .in("role", ["admin", "super_admin"])
        .limit(1)
        .maybeSingle();

      if (!cancelled) {
        setIsAdmin(!!data);
        setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [user, authLoading]);

  return { isAdmin, loading };
}
